import React from 'react';
import ReactDOM from 'react-dom/client';
import '@languages/index'
import './index.css';
import "@assets/scss/app.scss";
import App from './App';
import {TranslationCatalogProvider} from '@languages/TranslationCatalogProvider';
import {prepareQrEntry} from '@helper/qrEntry';


prepareQrEntry();
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <TranslationCatalogProvider>
      <App />
    </TranslationCatalogProvider>
  </React.StrictMode>
);
